import { Typo3ButtonNew } from '@/types/typo3'

const toDesignButton = (button: Typo3ButtonNew) => ({
  label: button?.label || button?.link?.title,
  href: button?.link?.href,
  variant: button?.variant,
  leftIcon: button?.iconPosition === 'left' && button?.icon,
  rightIcon: button?.iconPosition === 'right' && button?.icon,
  target: button?.link?.target
})

export default toDesignButton
